export enum AuthFields {
	privileges = 'Privileges',
	userEmailAddress = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
	userRole = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
	impersonatorEmail = 'ImpersonatorEmai',
	impersonatorId = 'ImpersonatorId',
	impersonatorUsername = 'ImpersonatorUsername',
	impersonatorViewPermission = 'ImpersonatorViewPermission',
	userType = 'User Type',
	userName = 'User Name',
	appInsightsConnectionString = 'AppInsightsConnectionString',
	hasTurkishBillingAgency = 'HasTurkishBillingAgency',
	contactId = 'ContactId'
}
